import { FunctionComponent } from "react"
import { dangerousInnerHtmlObj } from "../utils/sanitizer"
import { RootState, useTypedSelector } from "../app/store"

type SimulationCardType = {
  id: number
  name: string
  description: string
  imgUrl?: string
  imageData?: string // Data URI or SVG string for admin-uploaded images
  clickCallback: (simId: number) => void
  completed?: boolean
  state?: string
}

const SimulationCard: FunctionComponent<SimulationCardType> = ({
  id,
  name,
  description,
  imgUrl,
  imageData,
  clickCallback,
  completed = false,
  state = "",
}) => {
  const authStore = useTypedSelector((state: RootState) => {
    return state.authSlice
  })
  const isTeamMember = authStore.user.roles[0].roleId == 4
  return (
    <div
      id={`simulation-card-${id}`}
      className={`relative self-stretch rounded-xl bg-base-white shadow-[0px_1px_3px_rgba(16,_24,_40,_0.1),_0px_1px_2px_rgba(16,_24,_40,_0.06)] box-border w-[319px] overflow-hidden shrink-0 border-[1px] border-solid border-gray-200 ${
        completed && !isTeamMember
          ? "opacity-50 cursor-not-allowed grayscale pointer-events-none"
          : "cursor-pointer"
      }`}
      onClick={() => {
        if (isTeamMember) {
          clickCallback(id)
        } else {
          !completed && clickCallback(id)
        }
      }}>
      <div className="self-stretch flex flex-col p-6 items-start justify-start gap-[32px]">
        <div className="self-stretch flex flex-row items-start justify-between">
          {imageData && imageData.startsWith("<svg") ? (
            <div
              className="flex-1 relative max-w-full overflow-hidden h-[167px] flex items-center justify-center"
              dangerouslySetInnerHTML={{ __html: imageData }}
            />
          ) : imageData || imgUrl ? (
            <img
              className="flex-1 relative max-w-full overflow-hidden h-[167px] object-contain"
              alt=""
              src={imageData || imgUrl}
            />
          ) : (
            <div className="flex-1 relative max-w-full overflow-hidden h-[167px] flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 rounded-lg">
              <div className="flex flex-col items-center gap-2 text-indigo-300">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
                <span className="text-xs font-medium tracking-wide uppercase">Custom Simulation</span>
              </div>
            </div>
          )}
        </div>
        <div className="self-stretch flex flex-col items-start justify-start gap-[4px] text-left text-gray-900">
          <div className="self-stretch relative text-base leading-[28px] font-semibold">
            <span
              className={completed && !isTeamMember ? "z-20 relative" : ""}
              style={
                completed && !isTeamMember
                  ? { textShadow: "0 1px 8px rgba(0,0,0,0.18), 0 0 2px #fff" }
                  : {}
              }>
              {name}
            </span>

            <br />
            {isTeamMember && state && completed && (
              <span className="z-20 relative">{state}</span>
            )}
          </div>
          <div
            className="self-stretch relative leading-[24px] text-gray-600"
            dangerouslySetInnerHTML={dangerousInnerHtmlObj(description)}
          />
        </div>
      </div>
      {!isTeamMember && completed && (
        <div className="absolute inset-0 flex items-center justify-center z-10 backdrop-blur-sm bg-gradient-to-b from-gray-300/20 to-gray-700/20">
          <span className="px-6 py-2 rounded-full bg-white text-gray-700 font-semibold text-lg shadow-md border border-gray-300 backdrop-blur-sm drop-shadow-md">
            Completed
          </span>
        </div>
      )}
    </div>
  )
}

export default SimulationCard
